export * from './icon.module';
export * from './icon.component';
